import Main from '../../layouts/Main';
import Container from '../../components/Container';
import {Box} from '@mui/material';
import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import BostonElectionCharts from './components/BostonElectionCharts';

const BostonMayoralElection = (): JSX.Element => {

  document.title = 'OCPF - Boston Mayoral Election';

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Box marginBottom={2}></Box>
        <BostonElectionCharts></BostonElectionCharts>
      </Container>
    </Main>
  );
};

export default BostonMayoralElection;